<template>
    <div v-if="this.$store.state.device.isDesktop" class="sidenav">
        <b-row style="padding-top: 10%;">
            <router-link to="/dashboard">
                <span>{{ $t('pages.Menu.Dashboard')}}</span>
            </router-link>
        </b-row>

        <b-row>
            <router-link to="/listSocios">
                <span>{{ $t('pages.Menu.List')}}</span>
            </router-link>
        </b-row>

        <b-row>
            <router-link to="/createSocio">
                <span>{{ $t('pages.Menu.Registration')}}</span>
            </router-link>
        </b-row>

        <b-row>
            <router-link to="/listPayments">
                <span>{{ $t('pages.Menu.Payments')}}</span>
            </router-link>
        </b-row>

        <b-row>
            <router-link to="/csv">
                <span>{{ $t('pages.Menu.DownloadCsv')}}</span>
            </router-link>
        </b-row>

        <b-row>
            <router-link to="/suporte">
                <span>{{ $t('pages.Menu.Support')}}</span>
            </router-link>
        </b-row>

        <div class="flags_container_desktop">
            <a @click="changeToPt" class="flags_desktop"><country-flag country='pt' style="margin-right: 10px;"/></a>
            <a @click="changeToEn" class="flags_desktop"><country-flag country='gb'/></a>
        </div>
    </div>
</template>

<script>
    import CountryFlag from 'vue-country-flag'
    export default {
        name: "sideBar",
        components: { CountryFlag },
        data() {
            return {
                pt: null,
                en: null
            };
        },
        methods: {
            changeToEn: function() {
                this.$i18n.set('en');
                localStorage.setItem('language', 'en');
                this.en = true;
                this.pt = false;
                if(this.$router.currentRoute.path=='/csv') this.$router.go(0);
            },
            changeToPt: function() {
                this.$i18n.set('pt');
                localStorage.setItem('language', 'pt');
                this.en = false;
                this.pt = true;
                if(this.$router.currentRoute.path=='/csv') this.$router.go(0);
            }
        }
    }
</script>

<style scoped>
    .sidenav {
        height: 100%;
        width: 200px;
        position: fixed;
        top: 0;
        left: 0;
        background-color: #ECECEC;
        z-index: 999;
        padding-top: 32px;
        border-right: 1px solid #707070;
    }
    .sidenav a {
        width: 90%;
        padding: 6px 8px 6px 24px;
        color: #2B2D42;
        border-bottom: 1px solid #8D99AE;
    }
    span {
        float: left;
        padding: 8px;
    }
    .flags_container_desktop {
        width: 100%;
        position: absolute;
        bottom: 2vh;
        left: 25%;
    }
    .flags_desktop {
        border-bottom: 0 !important;
    }
</style>
